export default "__VITE_ASSET__BNtfN8SY__"